export enum GiftCardStatus {
  Cart = 'Cart',
  PendingPayment = 'PendingPayment',
  Active = 'Active',
  Used = 'Used',
  Expired = 'Expired',
}

export interface GiftCard {
  id?: number;
  uuid: string;
  locationId: number;
  code: string | null;
  value: number;
  expiresAt?: Date | string | null;
  status: GiftCardStatus;
  recipientName?: string;
  recipientEmail?: string;
  senderName?: string;
  senderEmail?: string;
  senderMessage?: string;
}
